/**
 * Generates a random number within the specified range.
 * @param min - The minimum value of the range (inclusive).
 * @param max - The maximum value of the range (inclusive).
 * @param isInteger - Whether the result should be an integer (default: true).
 * @returns A random number between min and max.
 */
function generateRandomNumber(min = 0, max = 1, isInteger = true) {
    const random = Math.random() * (max - min) + min;
    return isInteger ? Math.floor(random) : random;
}
const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function generateUUID(length = 12) {
    const array = crypto.getRandomValues(new Uint8Array(length));
    return Array.from(array, (byte) => CHARS[byte % CHARS.length]).join("");
}

export { generateRandomNumber, generateUUID };
//# sourceMappingURL=random.js.map
